import type { BrandFont } from "@/app/_module/lib/brandFonts";

export interface AgencyBranding {
  // Text overrides
  brandName: string;
  brandTagline: string;
  botName?: string;        // Replaces "InsuraBot"
  supportEmail: string;
  supportPhone?: string;

  // Color theme (HSL format to match CSS variables)
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  sidebarColor?: string;        // Main sidebar background
  sidebarTextColor?: string;    // Main sidebar text
  sidebarAccentColor?: string;  // Active/hover item background (the darker shade)
  sidebarAccentTextColor?: string; // Active/hover item text
  sidebarHeaderTextColor?: string; // Brand name at the top of the sidebar (white when unset)

  textFont?: BrandFont | null; // All text (lib/brandFonts); unset = the system font
  headingFont?: BrandFont | null; // Agency name at the top of the sidebar + page titles

  // Assets
  faviconUrl?: string;
  faviconPath?: string;
  loginBackgroundUrl?: string;
  loginBackgroundPath?: string;
  logoUrl?: string;

  // Layout
  logoSize?: number; // Logo dimensions in px (default 32)

  // White-label scope
  brandingScope?: 'self_only' | 'cascade'; // Whether branding cascades to sub-agencies

  // Feature flags
  hidePoweredBy?: boolean;

  /**
   * Per-agency "Get Rich or Die Dialing" premium sort. Enabled for select agencies
   * only (Duse / United Eagles / GFG). When present + enabled, the leads table shows
   * a sort option that orders by the agency's imported premium (custom_fields).
   * Delivered via the branding payload so the leads UI can gate it with no extra call.
   */
  premiumSort?: {
    enabled: boolean;
    label?: string;
  };
}

export const DEFAULT_BRANDING: AgencyBranding = {
  brandName: 'InsuraCentral',
  brandTagline: 'AI-powered life insurance CRM',
  supportEmail: 'support@insuracentral.com',
  brandingScope: 'self_only',
  hidePoweredBy: false,
};
